module.exports = __webpack_public_path__ + "static/media/calendar_icon.9c6d80ac.svg";